import { SeatCharacteristic as SeatCharacteristicEnum } from '@eti/schema-types';
export const iconMap = {
  [SeatCharacteristicEnum.LegSpace]: 'extralegroom',
  [SeatCharacteristicEnum.FrontOfCabin]: 'frontrow',
  [SeatCharacteristicEnum.EconomyComfort]: 'economy',
  [SeatCharacteristicEnum.Normal]: 'default',
  BASSINET: '',
  BULKHEAD: '',
  ELECTRONIC_CONNECTION: '',
  NOT_SUITABLE_FOR_CHILDREN: '',
  NO_INFANT_ALLOWED: '',
  SUITABLE_FOR_ADT_WITH_INF: ''
};
export const getSeatIconUrl = async (brand, characteristic) => {
  var _iconMap, _await$loadIcon;
  const key = (_iconMap = iconMap[characteristic]) !== null && _iconMap !== void 0 ? _iconMap : 'default';
  const loadIcon = async brandPath => {
    try {
      const icon = await import(`@eti/assets/icons/seating-buttons/${brandPath}/seatButton-${key}.svg?url`);
      return icon.default;
    } catch {
      return undefined;
    }
  };
  return (_await$loadIcon = await loadIcon(brand)) !== null && _await$loadIcon !== void 0 ? _await$loadIcon : await loadIcon('default');
};
//# sourceMappingURL=getSeatIconUrl.js.map